export const ADD_ACCOUNT = 'addAccount';
export const ADD_LEDGER_ACCOUNT = 'addLedgerAccount';
export const ADD_LEDGER_ETH_ACCOUNT = 'addLedgerEthAccount';
export const ADD_METAMASK_ACCOUNT = 'addMetamaskAccount';
export const UPDATE_ACCOUNT_BALANCE = 'udpateAccountBalance';
export const UPDATE_ACCOUNTS_BALANCES = 'udpateAccountsBalances';
export const UPDATE_ACCOUNT = 'updateAccount';
export const REMOVE_ACCOUNT_BY_ADDRESS = 'removeAccountByAddress';
